import AppInfo from "../data/AppInfo";
import FailedApiResponse from "../data/FailedApiResponse";
import SuccessApiResponse from "../data/SuccessApiResponse";
import IApiResponse from "../interfaces/IApiResponse";
import IHomeBanner from "../interfaces/IHomeBanner";

export interface IHomeBannerService {
    getHomeBannerInfo: () =>  Promise<IApiResponse<IHomeBanner>>,
}

const HomeBannerService: IHomeBannerService = {

  getHomeBannerInfo: () => {
      const fetchUrl = AppInfo.bannerUrl + `?v=${Date.now()}`;

      return fetch(
        fetchUrl,
        { 
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        })
          .then((response) =>{
            return response.json();
          })
          .then(async(bannerInfoJson) =>{
            SuccessApiResponse.Data = bannerInfoJson;
            return SuccessApiResponse;
          })
          .catch(error => {
            console.error(error);
            FailedApiResponse.Message.ServerMessage = error;
            return FailedApiResponse;
          });
    },
}

export default HomeBannerService;